export const storiesData = [
  {
    image: "https://myunibest.ir/stories/images/st31.png",
    video: "https://myunibest.ir/stories/videos/st31.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st32.png",
    video: "https://myunibest.ir/stories/videos/st32.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st33.png",
    video: "https://myunibest.ir/stories/videos/st33.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st34.png",
    video: "https://myunibest.ir/stories/videos/st34.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st35.png",
    video: "https://myunibest.ir/stories/videos/st35.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st36.png",
    video: "https://myunibest.ir/stories/videos/st36.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st37.png",
    video: "https://myunibest.ir/stories/videos/st37.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st38.png",
    video: "https://myunibest.ir/stories/videos/st38.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st39.png",
    video: "https://myunibest.ir/stories/videos/st39.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st40.png",
    video: "https://myunibest.ir/stories/videos/st40.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st41.png",
    video: "https://myunibest.ir/stories/videos/st41.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st42.png",
    video: "https://myunibest.ir/stories/videos/st42.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st43.png",
    video: "https://myunibest.ir/stories/videos/st43.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st44.png",
    video: "https://myunibest.ir/stories/videos/st44.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st45.png",
    video: "https://myunibest.ir/stories/videos/st45.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st46.png",
    video: "https://myunibest.ir/stories/videos/st46.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st47.png",
    video: "https://myunibest.ir/stories/videos/st47.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st48.png",
    video: "https://myunibest.ir/stories/videos/st48.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st49.png",
    video: "https://myunibest.ir/stories/videos/st49.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st50.png",
    video: "https://myunibest.ir/stories/videos/st50.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st51.png",
    video: "https://myunibest.ir/stories/videos/st51.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st52.png",
    video: "https://myunibest.ir/stories/videos/st52.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st53.png",
    video: "https://myunibest.ir/stories/videos/st53.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st54.png",
    video: "https://myunibest.ir/stories/videos/st54.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st55.png",
    video: "https://myunibest.ir/stories/videos/st55.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st56.png",
    video: "https://myunibest.ir/stories/videos/st56.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st57.png",
    video: "https://myunibest.ir/stories/videos/st57.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st58.png",
    video: "https://myunibest.ir/stories/videos/st58.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st59.png",
    video: "https://myunibest.ir/stories/videos/st59.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st60.png",
    video: "https://myunibest.ir/stories/videos/st60.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st61.png",
    video: "https://myunibest.ir/stories/videos/st61.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st62.png",
    video: "https://myunibest.ir/stories/videos/st62.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st63.png",
    video: "https://myunibest.ir/stories/videos/st63.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st64.png",
    video: "https://myunibest.ir/stories/videos/st64.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st65.png",
    video: "https://myunibest.ir/stories/videos/st65.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st66.png",
    video: "https://myunibest.ir/stories/videos/st66.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st67.png",
    video: "https://myunibest.ir/stories/videos/st67.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st68.png",
    video: "https://myunibest.ir/stories/videos/st68.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st69.png",
    video: "https://myunibest.ir/stories/videos/st69.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st70.png",
    video: "https://myunibest.ir/stories/videos/st70.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st71.png",
    video: "https://myunibest.ir/stories/videos/st71.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st72.png",
    video: "https://myunibest.ir/stories/videos/st72.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st73.png",
    video: "https://myunibest.ir/stories/videos/st73.mp4",
  },
  {
    image: "https://myunibest.ir/stories/images/st2.png",
    video: "https://myunibest.ir/stories/videos/st2.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st3.png",
    video: "https://myunibest.ir/stories/videos/st3.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st4.png",
    video: "https://myunibest.ir/stories/videos/st4.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st10.png",
    video: "https://myunibest.ir/stories/videos/st10.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st11.png",
    video: "https://myunibest.ir/stories/videos/st11.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st15.png",
    video: "https://myunibest.ir/stories/videos/st15.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st16.png",
    video: "https://myunibest.ir/stories/videos/st16.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st17.png",
    video: "https://myunibest.ir/stories/videos/st17.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st18.png",
    video: "https://myunibest.ir/stories/videos/st18.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st19.png",
    video: "https://myunibest.ir/stories/videos/st19.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st20.png",
    video: "https://myunibest.ir/stories/videos/st20.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st21.png",
    video: "https://myunibest.ir/stories/videos/st21.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st22.png",
    video: "https://myunibest.ir/stories/videos/st22.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st23.png",
    video: "https://myunibest.ir/stories/videos/st23.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st24.png",
    video: "https://myunibest.ir/stories/videos/st24.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st25.png",
    video: "https://myunibest.ir/stories/videos/st25.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st26.png",
    video: "https://myunibest.ir/stories/videos/st26.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st27.png",
    video: "https://myunibest.ir/stories/videos/st27.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st28.png",
    video: "https://myunibest.ir/stories/videos/st28.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st29.png",
    video: "https://myunibest.ir/stories/videos/st29.mov",
  },
  {
    image: "https://myunibest.ir/stories/images/st30.png",
    video: "https://myunibest.ir/stories/videos/st30.mov",
  },
];
